import { useEffect, useState } from "react";
import { Zap } from "lucide-react";

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-[#0f0f11]/70 backdrop-blur-xl border-b border-white/10" : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 h-[72px] flex items-center justify-between">
        <button data-testid="nav-logo" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} className="flex items-center gap-2 group">
          <span className="grid place-items-center w-8 h-8 bg-[#e2ff00] text-black rounded-sm rotate-3 group-hover:rotate-0 transition-transform">
            <Zap size={18} strokeWidth={2.5} />
          </span>
          <span className="font-display font-extrabold tracking-tight text-lg">OG VAULT</span>
        </button>

        <nav className="hidden md:flex items-center gap-9 font-mono text-xs uppercase tracking-[0.2em] text-[#8b8b93]">
          <button data-testid="nav-vault" onClick={() => go("vault")} className="hover:text-white transition-colors">Der Tresor</button>
          <button data-testid="nav-manifesto" onClick={() => go("manifesto")} className="hover:text-white transition-colors">Warum wir</button>
          <button data-testid="nav-how" onClick={() => go("how")} className="hover:text-white transition-colors">So funktioniert's</button>
        </nav>

        <button
          data-testid="nav-cta"
          onClick={() => go("vault")}
          className="font-mono text-xs uppercase tracking-[0.2em] bg-white text-black px-5 py-2.5 rounded-full hover:bg-[#e2ff00] transition-colors"
        >
          Packs ansehen
        </button>
      </div>
    </header>
  );
};
